exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen{#ticket[data-v-e268a3dc]{display:none}}", ""]);

// exports
